export const ENERGY_LABELS = Object.freeze({ pvPower: 'Solar generation', loadPower: 'Site demand', gridPower: 'Grid exchange', gridImportPower: 'Grid import', gridExportPower: 'Grid export', solarIrradiance: 'Solar irradiance' });
export function energyMeasurements(sample) {
  const result = {};
  for (const [key, metric] of Object.entries(sample?.measurements ?? {})) {
    const semantic = metric?.semanticKey ?? key.replace(/^measurements_/, '');
    if (Object.hasOwn(ENERGY_LABELS, semantic) && metric && !result[semantic]) result[semantic] = metric;
  }
  return result;
}
export function isEnergyTelemetry(sample) {
  const m = energyMeasurements(sample);
  return sample?.schema === 'objectid.telemetry.energy.v1' || sample?.simulation?.profile === 'energy' || Boolean(m.pvPower && m.loadPower && m.gridPower);
}
export function measurementLabel(key, metric) {
  return metric?.label || ENERGY_LABELS[metric?.semanticKey ?? key.replace(/^measurements_/, '')] || key.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/[_-]/g, ' ');
}
export function energyPower(metric) {
  if (typeof metric?.value !== 'number' || !Number.isFinite(metric.value)) return null;
  return metric.unit === 'kW' ? metric.value : metric.unit === 'W' ? metric.value / 1000 : metric.unit === 'MW' ? metric.value * 1000 : null;
}
export function measurementCompleteness(sample) {
  const m = sample?.measurements ?? {};
  const numeric = metric => typeof metric?.value === 'number' && Number.isFinite(metric.value);
  if (isEnergyTelemetry(sample)) {
    const values = energyMeasurements(sample);
    const count = ['pvPower', 'loadPower', 'gridPower'].filter(key => energyPower(values[key]) !== null).length;
    return { valid: count === 3, evidence: `${count}/3 energy power signals with supported units` };
  }
  if (sample?.schema === 'objectid.telemetry.classified.v1') {
    const count = Object.values(m).filter(numeric).length;
    return { valid: count > 0, evidence: `${count} numeric classified signals available` };
  }
  const count = ['temperature', 'vibration', 'rotationalSpeed', 'activePower', 'pressure'].filter(key => numeric(m[key])).length;
  return { valid: count === 5, evidence: `${count}/5 industrial numeric measurements` };
}
